import { Component, Inject, OnInit, Input, Optional } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { AlertDialogService } from '../../../../../services/alert-dialog.service';
import { Router } from '@angular/router';
import { CandidatesApplied, Mission } from '../../../../../models/Mission';
import {
  CandidatStatusOnMission,
  FlagType,
  MissionStatusEnum,
} from '../../../../../shared/utils/enums';
import {
  calculateDaysWithTime,
  calculDiffDays,
  displayImg,
  isMissionExpired,
} from '../../../../../shared/utils/utils.functions';
import moment from 'moment';
import { MissionService } from '../../../../../services/mission.service';
import { candidatAccepted } from '../../../../../shared/utils/data/shared.data';
import { CustomDialogComponent } from '../../../../../shared/custom-dialog/custom-dialog.component';
import {
  ChargeList,
  EtablissementData,
  FraisPostList,
} from '../../../../../shared/utils/data/etablissments-data';
import { FlagService } from '../../../../../shared/services/flag.service';
import { GenericCharge } from '../../../../../models/GenericCharge';
import { ImageDialogComponent } from '../../../../../shared/image-dialog/image-dialog.component';
import { stat } from 'fs';
import {
  MissionsRejectedComponent
} from "../../../../../pages/etablissement/missions/missions-rejected/missions-rejected.component";
import { MatLabel } from "@angular/material/form-field";
import { MatTabGroup } from "@angular/material/tabs";
import { SvgIconComponent } from "angular-svg-icon";
import { SharedModule } from "../../../../../shared/shared.module";
import { NgClass, NgIf } from "@angular/common";
import { MissionCandidaturesComponent } from "../mission-candidatures/mission-candidatures.component";
import { MessageDialogComponent } from '../../../../../shared/components/message-dialog/message-dialog.component';
import { log } from 'console';

@Component({
  selector: 'app-mission-details-1',
  templateUrl: './mission-details.component.html',
  styleUrl: './mission-details.component.scss',
  imports: [
    MatLabel,
    MatTabGroup,
    SvgIconComponent,
    SharedModule,
    NgClass,
    NgIf,
    MissionCandidaturesComponent
  ],
  standalone: true
})
export class MissionDetailsComponent implements OnInit {
  @Input() missionId: number | null = null;
  @Input() isEmbedded: boolean = false;
  @Input() hideActionButtons: boolean = false;
  hideCandidatures: boolean = false;

  title: string;
  condidat: any[] = [
    {
      name: 'Mme. Mathilde Lefevre',
      status: 1,
      img: '/assets/images/user.png',
    },
    { name: 'Mr. Alexandre Lambert', status: 1 },
    {
      name: 'Mme. Charlotte Rousseau',
      status: 0,
      img: '/assets/images/user1.png',
    },
    { name: '{candidat.name}', status: 0 },
    {
      name: 'Mr. Lambert Alexandre',
      status: 0,
      img: '/assets/images/user2.png',
    },
    { name: 'Mme. Mathilde Lefevre', status: 1 },
    {
      name: 'Mr. Alexandre Lambert',
      status: 1,
      img: '/assets/images/user1.png',
    },
    { name: 'Mme. Charlotte Rousseau', status: 0 },
    { name: '{candidat.name}', status: 0 },
    {
      name: 'Mr. Lambert Alexandre',
      status: 0,
      img: '/assets/images/user1.png',
    },
    { name: 'Mme. Mathilde Lefevre', status: 1 },
    {
      name: 'Mr. Alexandre Lambert',
      status: 1,
      img: '/assets/images/user2.png',
    },
    {
      name: 'Mme. Charlotte Rousseau',
      status: 0,
      img: '/assets/images/user2.png',
    },
    { name: '{candidat.name}', status: 0, img: '/assets/images/user1.png' },
    {
      name: 'Mr. Lambert Alexandre',
      status: 0,
      img: '/assets/images/user1.png',
    },
  ];
  condidatFilted: any[];
  mission: Mission | any;
  candidatesApplied: CandidatesApplied[] = [];
  candidatesAccepted: CandidatesApplied[] = [];
  candidatesToSign: CandidatesApplied[] = [];
  disableButton = false;
  expired = false;
  loading = false;
  fichePosteFiles: any[] = [];
  fichePosteId = null;
  etbId = 0;

  constructor(
    @Optional() public dialogRef: MatDialogRef<MissionDetailsComponent> | null,
    private alertDialogService: AlertDialogService,
    private dialog: MatDialog,
    private router: Router,
    private missionService: MissionService,
    private flag: FlagService,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any
  ) { }

  ngOnInit(): void {
    this.etbId = this.data?.etbId || 0;
    this.hideActionButtons = this.isEmbedded || this.data?.hideActionButtons || false;
    this.hideCandidatures = this.data?.hideCandidatures || false;
    this.condidatFilted = this.condidat.filter((el) => el.status != 1);
    this.title = this.data?.titre || 'Mission';
    this.getMissionById();
  }

  getMissionById() {
    this.loading = true;
    // this.missionService.getMissionById(this.data.id || this.data.mission_id).subscribe(value => {
    //   this.mission = value;
    //   this.loading = false;
    //   this.expired =isMissionExpired(this.mission.enddate, this.mission.endtime)
    //   this.candidatesAccepted = this.mission.candidatesApplied
    //     .filter(c => candidatAccepted.includes(c.statusOfCandidatOnMission)
    //       && this.mission.missionStatus == MissionStatusEnum.PENDING  && this.expired)

    // })
    const missionIdToFetch = this.missionId || this.data?.id || this.data?.mission_id;
    this.missionService
      .getMissionById(missionIdToFetch, "/v2")
      .subscribe({
        next: (value) => {
          this.mission = value;
          this.loading = false;
          this.fichePosteId = value.fichePosteId;
          this.expired = isMissionExpired(
            this.mission.enddate,
            this.mission.endtime
          );
          this.candidatesToSign = this.mission.candidatesApplied.filter(
            (c: any) =>
              candidatAccepted.includes(c.statusOfCandidatOnMission) &&
              this.mission.missionStatus == MissionStatusEnum.PENDING &&
              this.expired
          );
          this.candidatesAccepted = this.mission.candidatesApplied.filter(
            (c: any) =>
              candidatAccepted.includes(c.statusOfCandidatOnMission) &&
              this.mission.missionStatus == MissionStatusEnum.PENDING &&
              !this.expired
          );

          if (this.fichePosteId) {
            this.getFichePost();
          }
        },
        error: (err) => {
          if (this.dialogRef) {
            this.dialogRef.close();
          }
        },
      });
  }
  getFile(files: any, label: string): void { }
  getFichePost() {
    this.missionService
      .getFichePosteById(this.fichePosteId)
      .subscribe((res: any) => {
        //

        let file = new File(
          ['data:application/pdf;base64,' + res?.pdfContent],
          res?.name + '.pdf',
          {
            type: 'application/pdf',
          }
        );
        this.fichePosteFiles = [
          {
            file,
            url: 'data:application/pdf;base64,' + res.pdfContent,
          },
        ];
      });
  }
  get statusMission(): any {
    if (this.mission.isfragmentable) {
      return this.mission.missionStatus;
    }
    const expired = isMissionExpired(
      this.mission.enddate,
      this.mission.endtime
    );
    //  const candidateAccepted = this.candidatesAccepted.length > 0;
    var list = this.mission.candidatesApplied;
    var index = list?.findIndex((c: any) =>
      candidatAccepted.includes(c.statusOfCandidatOnMission)
    );
    var status = CandidatStatusOnMission.PENDING;
    if (index > -1 && !expired) {
      status =
        list[
          index
        ].statusOfCandidatOnMission;
    } else {
      if (expired) {
        status = CandidatStatusOnMission.EXPIRED;
      }
      if (expired && this.mission.missionStatus == MissionStatusEnum.PENDING) {
        status = CandidatStatusOnMission.WAITING_FOR_VALIDATION;
      }
      if (this.mission.missionStatus == MissionStatusEnum.DRAFT) {
        status = CandidatStatusOnMission.DRAFT;
      }
      if (
        status == CandidatStatusOnMission.PENDING &&
        expired
      ) {
        status = CandidatStatusOnMission.EXPIRED;
      }

      if (this.mission.missionStatus == CandidatStatusOnMission.INVALIDATED) {
        status = CandidatStatusOnMission.INVALIDATED;
      }
      if (this.mission.missionStatus == CandidatStatusOnMission.VALIDATED) {
        status = CandidatStatusOnMission.VALIDATED;
      }

    }

    return status;



  }

  // Coherent badge: a canceled offer/candidacy must read "Offre de mission annulée"
  // instead of falling through to the mission-level status (e.g. "Publiée en attente").
  get isCanceledOffer(): boolean {
    const s = this.data?.statusOfCandidatOnMission;
    return this.mission?.missionStatus === MissionStatusEnum.CANCELED
      || s === CandidatStatusOnMission.CANCELED_BY_CANDIDATE
      || s === CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY
      || s === CandidatStatusOnMission.CANCELLATION_ACCEPTED_AFTER_SIGNING;
  }

  get typeTag(): number {
    if (this.isCanceledOffer) {
      return 3;
    }
    switch (this.statusMission) {
      case MissionStatusEnum.FRAGMENTED_ALL_ASIGNED:
        return 1;

      case MissionStatusEnum.FRAGMENTED_NOT_ALL_ASIGNED:
        return 1;

      case CandidatStatusOnMission.VALIDATED:
        return 1;

      case CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION:
        return 1;

      case CandidatStatusOnMission.ACCEPTED:
        return 1;

      case CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH:
        return 1;
      case CandidatStatusOnMission.WAITING_FOR_VALIDATION:
        return 1;

      case CandidatStatusOnMission.INVALIDATED:
        return 3;

      case CandidatStatusOnMission.EXPIRED:
        return 3;

      case CandidatStatusOnMission.PENDING:
        return 2;

      default:
        return 0;
    }
  }

  get labelTag(): string {
    if (this.isCanceledOffer) {
      return 'Offre de mission annulée';
    }
    switch (this.statusMission) {
      case MissionStatusEnum.FRAGMENTED_ALL_ASIGNED:
        return 'Offre de mission totalement affectéee';

      case MissionStatusEnum.FRAGMENTED_NOT_ALL_ASIGNED:
        return 'Offre de mission partiellement affectée';

      case CandidatStatusOnMission.VALIDATED:
        return 'Validée';

      case CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION:
        return 'Publiée en attente';

      case CandidatStatusOnMission.INVALIDATED:
        return 'À Valider';

      case CandidatStatusOnMission.EXPIRED:
        return 'Terminée';

      case CandidatStatusOnMission.WAITING_FOR_VALIDATION:
        return 'En attente de validation';

      case CandidatStatusOnMission.ACCEPTED:
        return 'Acceptée';

      case CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH:
        return 'Offre totalement affectée';

      case CandidatStatusOnMission.PENDING:
        return 'Publiée en attente';

      case CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY:
        return 'Publiée en attente';

      default:
        return 'Draft';
    }
  }

  onDialogClose(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
  openImage(img: any) {
    const dialog = this.dialog.open(ImageDialogComponent, {
      backdropClass: 'bg-transparent',
      data: img,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
      }
    });
  }
  confirmValidation() {
    this.alertDialogService
      ?.openAlertModal(
        'success',
        'Confirmation de la validation de la mission',
        'Êtes-vous sûr(e) de vouloir valider cette mission ? ' +
        'Une fois validée,' +
        " vous pourrez procéder à l'évaluation du candidat. Cette action est irréversible.",
        'Valider la mission',
        'Annuler',
        '550px',
        true
      )
      ?.subscribe((res) => {


        if (res) {
          const body = {
            candidatId: this.candidatesToSign[0].candidatId,
            missionsId: this.mission.id,
            missionStatus: MissionStatusEnum.VALIDATED,
          };
          this.missionService.updateMissionStatus(body).subscribe({
            next: (result) => {
              const id = this.mission.id;
              this.router.navigate([`/agency/validation/${id}`])
              this.onDialogClose();
            },
          });
        }
      });
  }

  cancelValidation() {
    this.alertDialogService
      ?.openAlertModal(
        'success',
        'Confirmation de la Non-validation de la mission',
        `Êtes-vous sûr(e) de ne pas vouloir valider cette mission ?
      Cela signifiera que la mission n'a pas été réalisée correctement à cause d'un ou de plusieurs problèmes avec le professionnel de santé.`,
        'Ne pas valider la mission',
        'Annuler',
        '550px',
        false
      )
      ?.subscribe((res) => {
        if (res) {
          const body = {
            candidatId: this.candidatesToSign[0].candidatId,
            missionsId: this.mission.id,
            missionStatus: MissionStatusEnum.INVALIDATED,
          };
          this.missionService.updateMissionStatus(body).subscribe({
            next: (result) => {
              const dial = this.dialog.open(MissionsRejectedComponent, {
                width: '706px',
                backdropClass: 'bg-transparent',
                data: {
                  mission: this.mission,
                  candidat: this.candidatesToSign[0],
                },
              });
              dial.afterClosed().subscribe((value) => {
                this.missionService.toggleRefreshMission();
                this.onDialogClose();
              });
            },
          });
        }
      });
  }

  archiveMission() {
    const dialog = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.mission.archive.title,
        description: EtablissementData.mission.archive.description,
        primaryLabel: EtablissementData.mission.archive.primaryButton,
        secondaryLabel: EtablissementData.mission.archive.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        const body = {
          candidatId: null,
          missionId: this.mission.id,
          status: CandidatStatusOnMission.ARCHIVED,
        };
        this.missionService.deleteMission(this.mission.id).subscribe({
          next: (res) => {
            this.missionService.toggleRefreshMission();
            this.onDialogClose();
            this.flag.displayFlag(
              `La mission ${this.mission.missionTitle} à été annulée !`,
              FlagType.success
            );
          },
          error: (err) => {
            // this.flag.displayFlag('')
          },
        });
      }
    });
  }

  duplicateMission() {
    const dialog = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.mission.duplicate.title,
        description: EtablissementData.mission.duplicate.description,
        primaryLabel: EtablissementData.mission.duplicate.primaryButton,
        secondaryLabel: EtablissementData.mission.duplicate.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.disableButton = true;
        this.missionService.duplicateMission(this.mission.id).subscribe({
          next: (value) => {
            this.missionService.toggleRefreshMission();
            this.onDialogClose();
            this.disableButton = false;
          },
          error: (err) => {
            this.disableButton = false;
          },
        });
      }
    });
  }

  openMessageDialog(event: MouseEvent) {
    this.dialog.open(MessageDialogComponent, {
      width: '370px',
      position: {
        top: '32px',
        right: '32px'
      },
      panelClass: ['chat-popover-panel', 'arrow-none'],
      data: {
        // Vous pouvez passer ici des infos sur le candidat ou la mission si besoin
      }
    });
  }

    getFormattedTime(timeString: string) {
      if (timeString) {
        // Check if starttime is not null
        const [hours, minutes] = timeString.split(':'); // Split the time string
        const date = new Date(); // Get the current date
        date.setHours(parseInt(hours, 10), parseInt(minutes, 10)); // Set hours and minutes
        return moment(date).format('HH:mm'); // Format to HH:mm
      }
      return ''; // Return an empty string or handle the null case appropriately
    }
    
  protected readonly MissionStatusEnum = MissionStatusEnum;
  protected readonly calculDiffDays = calculateDaysWithTime;
  protected readonly moment = moment;
  protected readonly CandidatStatusOnMission = CandidatStatusOnMission;
  protected readonly ChargeList = ChargeList;
  protected readonly FraisPostList = FraisPostList;
  protected readonly displayImg = displayImg;

  // Computed property: does the mission have per-day hours?
  get hasPerDayHours(): boolean {
    return !!this.mission?.dailyHours?.length && this.mission?.applySameHoursToAllDays === false;
  }

  // Display daily hours directly from the mission data
  get missionDaysWithHours(): { date: Date; label: string; startTime: string; endTime: string; pauseTime: number }[] {
    const mission = this.mission;
    if (!mission?.dailyHours?.length) {
      return [];
    }

    return mission.dailyHours
      .filter((dh: any) => dh.date)
      .map((dh: any) => {
        const d = moment(dh.date);
        return {
          date: d.toDate(),
          label: d.locale('fr').format('dddd DD/MM/YYYY'),
          startTime: dh.startTime || '',
          endTime: dh.endTime || '',
          pauseTime: dh.pauseTime ?? 0
        };
      });
  }

}
